export default "__VITE_ASSET__CjdLDmgR__"